<template>
    <div id="modalTool">
        <div v-if="type === 'profit'">
            <profit-loss
                @pick-point="pickPoint"
                @complete="complete"
                @close="close"
                :default-traits="defaultTraits"
                :symbol="symbol"
            >
            </profit-loss>
        </div>
        <div v-if="type === 'risk'">
            <reward-risk
                @pick-point="pickPoint"
                @complete="complete"
                @close="close"
                :default-traits="defaultTraits"
                :symbol="symbol"
            >
            </reward-risk>
        </div>
        <div v-if="type === 'fiftyPercent'">
            <fifty-percent
                @pick-point="pickPoint"
                @complete="complete"
                @close="close"
                :default-traits="defaultTraits"
                :symbol="symbol"
            >
            </fifty-percent>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import ProfitLoss from './ProfitLoss';
import RewardRisk from './RewardRisk';
import FiftyPercent from './FiftyPercent';

const props = defineProps({
    type: String,
    symbol: String,
    defaultTraits: {
        type: Object,
        required: false
    }
});

const emit = defineEmits(['pick', 'close', 'add']);

function pickPoint() {
    emit('pick');
}

function complete(pToolName, pTraits, pValue) {
    emit('add', pToolName, pTraits, pValue);
}

function close() {
    emit('close');
}
</script>
